export const getFulfilmentTypeText = (order, props) => {
  const { t } = props;
  const { order_type } = order;
  const isUpcomingOrder =
    order.order_state !== "Expired" &&
    order.order_state !== "Completed" &&
    order.order_state !== "Cancelled";
  switch (true) {
    case order_type === "delivery" && isUpcomingOrder:
      return t("orderHistory.deliveringTo");
    case order_type === "delivery" && !isUpcomingOrder:
      return t("orderHistory.deliveredTo");
    case order_type === "pickup" && isUpcomingOrder:
      return t("orderHistory.pickingUpFrom");
    case order_type === "pickup" && !isUpcomingOrder:
      return t("orderHistory.pickUpFrom");
    default:
      return "";
  }
};

export const getStatus = (orderState, props) => {
  const { t } = props;
  switch (orderState) {
    case "Cancelled":
      return {
        value: t("orderHistory.cancelled"),
        color: "#C0392B",
        message: t("orderHistory.cancelledMessage"),
      };
    case "Expired":
      return {
        value: t("orderHistory.expired"),
        color: "#AC0D0D",
        message: t("orderHistory.expiredMessage"),
      };
    case "Completed":
      return {
        value: t("orderHistory.completed"),
        color: "#008000",
        message: t("orderHistory.completedMessage"),
      };
    case "Placed":
      return {
        value: t("orderHistory.placed"),
        color: "#FB6D3A",
        message: t("orderHistory.placedMessage"),
      };
    case "Acknowledged":
      return {
        value: t("orderHistory.acknowledged"),
        color: "#8E44AD",
        message: t("orderHistory.acknowledgedMessage"),
      };
    case "Food Ready":
      return {
        value: t("orderHistory.foodReady"),
        color: "#8E44AD",
        message: t("orderHistory.foodReadyMessage"),
      };
    case "Dispatched":
      return {
        value: t("orderHistory.dispatched"),
        color: "#8E44AD",
        message: t("orderHistory.dispatchedMessage"),
      };
    case "Awaiting Payment":
      return {
        value: t("orderHistory.awaitingPayment"),
        color: "#8E44AD",
        message: t("orderHistory.awaitingPaymentMessage"),
      };
    default:
      return {
        value: t("orderHistory.awaitingPayment"),
        color: "#8E44AD",
        message: t("orderHistory.awaitingPaymentMessage"),
      };
  }
};

export const qsrOrderStatus = (orderState) => {
  switch (orderState) {
    case "Cancelled":
    case "CANCELLED":
      return "cancelled";
    case "Completed":
    case "COMPLETED":
      return "completed";
    case "Placed":
    case "PLACED":
      return "preparing-food";
    case "Acknowledged":
    case "ACKNOWLEDGED":
      return "preparing-food";
    case "Food Ready":
    case "FOODREADY":
      return "food-prepared";
    case "Dispatched":
    case "DISPATCHED":
      return "food-prepared";
    default:
      return "preparing-food";
  }
};
